import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { OPEN_POSITION_RESOURCE } from "./use-open-position-search.query";

export const OPEN_POSITION_BULK_DELETE_API_PATH = `/v1/${OPEN_POSITION_RESOURCE}/bulk-delete` as const;

export type OpenPositionBulkDeleteResponse =
  paths[typeof OPEN_POSITION_BULK_DELETE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export function useOpenPositionBulkDeleteMutation() {
  const queryClient = useQueryClient();

  return useMutation<OpenPositionBulkDeleteResponse, Error, void>({
    mutationFn: async () => {
      const response = await alphartisApiAxios.post<OpenPositionBulkDeleteResponse>(OPEN_POSITION_BULK_DELETE_API_PATH);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [OPEN_POSITION_RESOURCE] });
    },
  });
}
